import React from "react";
import { Field, reduxForm } from "redux-form";
import { RenderSelect } from "components/Fields";

const ReduxForm = ({
  isFetching,
  handleSubmit,
  valid,
  optionsFormats,
  optionsBannerplaces,
  onChangeBannerPlace
}) => (
  <form onSubmit={handleSubmit}>
    <div>
      <div className="row">
        <div className="col-xs-5">
          <Field
            name="bannerPlaces"
            label="Баннерное место"
            component={RenderSelect}
            optionsToRender={optionsBannerplaces}
            onChange={onChangeBannerPlace}
            multi={true}
            clearable={false}
            disabled={isFetching}
          />
        </div>
        <div className="col-xs-5">
          <Field
            name="formats"
            label="Форматы"
            component={RenderSelect}
            optionsToRender={optionsFormats}
            multi={true}
            clearable={false}
            disabled={isFetching}
          />
        </div>
        <div className="col-xs-2">
          <button
            type="submit"
            className="btn btn-primary btn-sm pull-right bottomed-1"
            disabled={!valid || isFetching}
          >
            <i className="fas fa-sync r-5" /> Обновить
          </button>
        </div>
      </div>
    </div>
    <hr className="overed" />
  </form>
);

export default reduxForm({
  form: "statForm",
  enableReinitialize: true
})(ReduxForm);
